import { OneOnOneAgenda } from 'screens/oneOnOneRabbit/interfaces/OneOnOneAgenda';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';

import {
  addAgendaFromLibraryToInstanceApi,
  getOneOnOneAgendaLibraryApi,
  getOneOnOneAgendaLibraryForSettingsApi,
} from '../api';
import { LibraryTypeI, oneOnOneAgendaLibraryValidator } from '../interface';

export const getOneOnOneAgendaLibrary = async ({ masterId, instanceId, type }: OneOnOneRequestI & LibraryTypeI) => {
  try {
    const res = await getOneOnOneAgendaLibraryApi({
      masterId,
      instanceId,
      type,
    });
    const data = oneOnOneAgendaLibraryValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error fetching one on one agenda library ', error);
  }
};

export const addAgendaFromLibraryToInstance = async ({
  masterId,
  instanceId,
  libraryAgendaId,
  agendaText,
}: OneOnOneRequestI & { libraryAgendaId: number; agendaText: string }) => {
  try {
    const res = await addAgendaFromLibraryToInstanceApi({
      masterId,
      instanceId,
      libraryAgendaId,
      agendaText,
    });
    const data = OneOnOneAgenda.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error adding one on one agenda from library ', error);
  }
};

export const getOneOnOneAgendaLibraryForSettings = async ({ type }: LibraryTypeI) => {
  try {
    const res = await getOneOnOneAgendaLibraryForSettingsApi({
      type,
    });
    const data = oneOnOneAgendaLibraryValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error fetching one on one agenda library for settings ', error);
  }
};
